import {
  FETCH_PIPE_MILL_REPORTS,
  FETCH_PIPE_MILL_REPORTS_SUCCESS,
  FETCH_PIPE_MILL_REPORTS_FAILURE,
  FETCH_PIPE_MILL_MOCK_DATA,
  FETCH_PIPE_MILL_MOCK_DATA_SUCCESS,
  FETCH_PIPE_MILL_MOCK_DATA_FAILURE,
  FETCH_PIPE_MILL_REPORT_METADATA,
  FETCH_PIPE_MILL_REPORT_METADATA_SUCCESS,
  FETCH_PIPE_MILL_REPORT_METADATA_FAILURE,
  SAVE_PIPE_MILL_REPORT,
  SAVE_PIPE_MILL_REPORT_SUCCESS,
  SAVE_PIPE_MILL_REPORT_FAILURE,
  SAVE_BULK_PIPE_MILL_REPORTS,
  SAVE_BULK_PIPE_MILL_REPORTS_SUCCESS,
  SAVE_BULK_PIPE_MILL_REPORTS_FAILURE,
  SAVE_PIPE_MILL_REPORT_ITEM,
  SAVE_PIPE_MILL_REPORT_ITEM_SUCCESS,
  SAVE_PIPE_MILL_REPORT_ITEM_FAILURE,
  SAVE_PIPE_MILL_REPORT_STATUS,
  SAVE_PIPE_MILL_REPORT_STATUS_SUCCESS,
  SAVE_PIPE_MILL_REPORT_STATUS_FAILURE,
  DELETE_PIPE_MILL_REPORT,
  DELETE_PIPE_MILL_REPORT_SUCCESS,
  DELETE_PIPE_MILL_REPORT_FAILURE,
  DELETE_PIPE_MILL_REPORT_ITEM,
  DELETE_PIPE_MILL_REPORT_ITEM_SUCCESS,
  DELETE_PIPE_MILL_REPORT_ITEM_FAILURE,
  EVALUATE_PIPE_MILL_REPORT,
  EVALUATE_PIPE_MILL_REPORT_SUCCESS,
  EVALUATE_PIPE_MILL_REPORT_FAILURE,
  FETCH_PIPE_MILL_PROJECT_LIMITS,
  FETCH_PIPE_MILL_PROJECT_LIMITS_SUCCESS,
  FETCH_PIPE_MILL_PROJECT_LIMITS_FAILURE,
  SAVE_PIPE_MILL_PROJECT_LIMIT,
  SAVE_PIPE_MILL_PROJECT_LIMIT_SUCCESS,
  SAVE_PIPE_MILL_PROJECT_LIMIT_FAILURE,
  DELETE_PIPE_MILL_PROJECT_LIMIT,
  DELETE_PIPE_MILL_PROJECT_LIMIT_SUCCESS,
  DELETE_PIPE_MILL_PROJECT_LIMIT_FAILURE,
  FETCH_PIPE_MILL_FREQUENCY_RULES,
  FETCH_PIPE_MILL_FREQUENCY_RULES_SUCCESS,
  FETCH_PIPE_MILL_FREQUENCY_RULES_FAILURE,
  SAVE_PIPE_MILL_FREQUENCY_RULE,
  SAVE_PIPE_MILL_FREQUENCY_RULE_SUCCESS,
  SAVE_PIPE_MILL_FREQUENCY_RULE_FAILURE,
  DELETE_PIPE_MILL_FREQUENCY_RULE,
  DELETE_PIPE_MILL_FREQUENCY_RULE_SUCCESS,
  DELETE_PIPE_MILL_FREQUENCY_RULE_FAILURE,
  FETCH_PIPE_MILL_CLEARANCE_STATUS,
  FETCH_PIPE_MILL_CLEARANCE_STATUS_SUCCESS,
  FETCH_PIPE_MILL_CLEARANCE_STATUS_FAILURE,
  CLEAR_PIPE_MILL_REPORT_SAVE_STATUS,
  CLEAR_PIPE_MILL_REPORT_ERRORS,
} from './types';

export const fetchPipeMillReports = (payload) => ({ type: FETCH_PIPE_MILL_REPORTS, payload: payload || {} });
export const fetchPipeMillReportsSuccess = (payload) => ({ type: FETCH_PIPE_MILL_REPORTS_SUCCESS, payload });
export const fetchPipeMillReportsFailure = (error) => ({ type: FETCH_PIPE_MILL_REPORTS_FAILURE, error });

export const fetchPipeMillMockData = (payload) => ({ type: FETCH_PIPE_MILL_MOCK_DATA, payload: payload || {} });
export const fetchPipeMillMockDataSuccess = (payload) => ({ type: FETCH_PIPE_MILL_MOCK_DATA_SUCCESS, payload });
export const fetchPipeMillMockDataFailure = (error) => ({ type: FETCH_PIPE_MILL_MOCK_DATA_FAILURE, error });

export const fetchPipeMillReportMetadata = (payload) => ({ type: FETCH_PIPE_MILL_REPORT_METADATA, payload: payload || {} });
export const fetchPipeMillReportMetadataSuccess = (payload) => ({ type: FETCH_PIPE_MILL_REPORT_METADATA_SUCCESS, payload });
export const fetchPipeMillReportMetadataFailure = (error) => ({ type: FETCH_PIPE_MILL_REPORT_METADATA_FAILURE, error });

export const savePipeMillReport = (payload) => ({ type: SAVE_PIPE_MILL_REPORT, payload });
export const savePipeMillReportSuccess = (payload) => ({ type: SAVE_PIPE_MILL_REPORT_SUCCESS, payload });
export const savePipeMillReportFailure = (error) => ({ type: SAVE_PIPE_MILL_REPORT_FAILURE, error });

export const saveBulkPipeMillReports = (payload) => ({ type: SAVE_BULK_PIPE_MILL_REPORTS, payload });
export const saveBulkPipeMillReportsSuccess = (payload) => ({ type: SAVE_BULK_PIPE_MILL_REPORTS_SUCCESS, payload });
export const saveBulkPipeMillReportsFailure = (error) => ({ type: SAVE_BULK_PIPE_MILL_REPORTS_FAILURE, error });

export const savePipeMillReportItem = (payload) => ({ type: SAVE_PIPE_MILL_REPORT_ITEM, payload });
export const savePipeMillReportItemSuccess = (payload) => ({ type: SAVE_PIPE_MILL_REPORT_ITEM_SUCCESS, payload });
export const savePipeMillReportItemFailure = (error) => ({ type: SAVE_PIPE_MILL_REPORT_ITEM_FAILURE, error });

export const savePipeMillReportStatus = (payload) => ({ type: SAVE_PIPE_MILL_REPORT_STATUS, payload });
export const savePipeMillReportStatusSuccess = (payload) => ({ type: SAVE_PIPE_MILL_REPORT_STATUS_SUCCESS, payload });
export const savePipeMillReportStatusFailure = (error) => ({ type: SAVE_PIPE_MILL_REPORT_STATUS_FAILURE, error });

export const deletePipeMillReport = (payload) => ({ type: DELETE_PIPE_MILL_REPORT, payload });
export const deletePipeMillReportSuccess = (payload) => ({ type: DELETE_PIPE_MILL_REPORT_SUCCESS, payload });
export const deletePipeMillReportFailure = (error) => ({ type: DELETE_PIPE_MILL_REPORT_FAILURE, error });

export const deletePipeMillReportItem = (payload) => ({ type: DELETE_PIPE_MILL_REPORT_ITEM, payload });
export const deletePipeMillReportItemSuccess = (payload) => ({ type: DELETE_PIPE_MILL_REPORT_ITEM_SUCCESS, payload });
export const deletePipeMillReportItemFailure = (error) => ({ type: DELETE_PIPE_MILL_REPORT_ITEM_FAILURE, error });

export const evaluatePipeMillReport = (payload) => ({ type: EVALUATE_PIPE_MILL_REPORT, payload });
export const evaluatePipeMillReportSuccess = (payload) => ({ type: EVALUATE_PIPE_MILL_REPORT_SUCCESS, payload });
export const evaluatePipeMillReportFailure = (error) => ({ type: EVALUATE_PIPE_MILL_REPORT_FAILURE, error });

export const fetchPipeMillProjectLimits = (payload) => ({ type: FETCH_PIPE_MILL_PROJECT_LIMITS, payload: payload || {} });
export const fetchPipeMillProjectLimitsSuccess = (payload) => ({ type: FETCH_PIPE_MILL_PROJECT_LIMITS_SUCCESS, payload });
export const fetchPipeMillProjectLimitsFailure = (error) => ({ type: FETCH_PIPE_MILL_PROJECT_LIMITS_FAILURE, error });

export const savePipeMillProjectLimit = (payload) => ({ type: SAVE_PIPE_MILL_PROJECT_LIMIT, payload });
export const savePipeMillProjectLimitSuccess = (payload) => ({ type: SAVE_PIPE_MILL_PROJECT_LIMIT_SUCCESS, payload });
export const savePipeMillProjectLimitFailure = (error) => ({ type: SAVE_PIPE_MILL_PROJECT_LIMIT_FAILURE, error });

export const deletePipeMillProjectLimit = (payload) => ({ type: DELETE_PIPE_MILL_PROJECT_LIMIT, payload });
export const deletePipeMillProjectLimitSuccess = (payload) => ({ type: DELETE_PIPE_MILL_PROJECT_LIMIT_SUCCESS, payload });
export const deletePipeMillProjectLimitFailure = (error) => ({ type: DELETE_PIPE_MILL_PROJECT_LIMIT_FAILURE, error });

export const fetchPipeMillFrequencyRules = (payload) => ({ type: FETCH_PIPE_MILL_FREQUENCY_RULES, payload: payload || {} });
export const fetchPipeMillFrequencyRulesSuccess = (payload) => ({ type: FETCH_PIPE_MILL_FREQUENCY_RULES_SUCCESS, payload });
export const fetchPipeMillFrequencyRulesFailure = (error) => ({ type: FETCH_PIPE_MILL_FREQUENCY_RULES_FAILURE, error });

export const savePipeMillFrequencyRule = (payload) => ({ type: SAVE_PIPE_MILL_FREQUENCY_RULE, payload });
export const savePipeMillFrequencyRuleSuccess = (payload) => ({ type: SAVE_PIPE_MILL_FREQUENCY_RULE_SUCCESS, payload });
export const savePipeMillFrequencyRuleFailure = (error) => ({ type: SAVE_PIPE_MILL_FREQUENCY_RULE_FAILURE, error });

export const deletePipeMillFrequencyRule = (payload) => ({ type: DELETE_PIPE_MILL_FREQUENCY_RULE, payload });
export const deletePipeMillFrequencyRuleSuccess = (payload) => ({ type: DELETE_PIPE_MILL_FREQUENCY_RULE_SUCCESS, payload });
export const deletePipeMillFrequencyRuleFailure = (error) => ({ type: DELETE_PIPE_MILL_FREQUENCY_RULE_FAILURE, error });

export const fetchPipeMillClearanceStatus = (payload) => ({ type: FETCH_PIPE_MILL_CLEARANCE_STATUS, payload: payload || {} });
export const fetchPipeMillClearanceStatusSuccess = (payload) => ({ type: FETCH_PIPE_MILL_CLEARANCE_STATUS_SUCCESS, payload });
export const fetchPipeMillClearanceStatusFailure = (error) => ({ type: FETCH_PIPE_MILL_CLEARANCE_STATUS_FAILURE, error });

export const clearPipeMillReportSaveStatus = () => ({ type: CLEAR_PIPE_MILL_REPORT_SAVE_STATUS });
export const clearPipeMillReportErrors = () => ({ type: CLEAR_PIPE_MILL_REPORT_ERRORS });
